var _circle, _text, _text2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPnLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "600px",
    height: "600px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "lgrad",
    x1: "50%",
    y1: "0%",
    x2: "50%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "rgb(0,151,178)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "rgb(126,217,87)",
      stopOpacity: 1
    }
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 300,
    cy: 300,
    r: 300,
    width: "100%",
    height: "100%",
    fill: "url(#lgrad)"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 300,
    y: 450,
    fontSize: 440,
    textAnchor: "middle",
    fontWeight: "bold",
    fill: "#1C8B6FAD"
  }, "N")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 289,
    y: 450,
    fontSize: 450,
    textAnchor: "middle",
    fontWeight: "bold",
    fill: "black"
  }, "P")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPnLogo);
export default __webpack_public_path__ + "static/media/pn_logo.3e90a438097a1dedf5d10c1d73aada19.svg";
export { ForwardRef as ReactComponent };